import { WithTimeUnit } from '@mews-commander/types';
import { TimeUnit } from '@mews/enums';
import { IntervalDateFieldsProps, IntervalTimeFieldsProps } from '../../types';
import DateIntervalFields from './DateIntervalFields';
import { HourIntervalFields } from './HourIntervalFields';
import MonthIntervalFields from './MonthIntervalFields';

const TimeUnitIntervalFields = ({
    timeUnit,
    ...props
}: (IntervalDateFieldsProps | IntervalTimeFieldsProps) & WithTimeUnit) => {
    switch (timeUnit) {
        case TimeUnit.Month:
            return <MonthIntervalFields {...props} />;
        case TimeUnit.Hour:
            return <HourIntervalFields {...props} />;
        default:
            return <DateIntervalFields {...props} />;
    }
};

export default TimeUnitIntervalFields;
